import React, { useState, useRef, useEffect } from "react";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from 'react-router-dom'
import { useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import { confirmAlert } from "react-confirm-alert";
import CurrencyInput from 'react-currency-input-field';
import { ToastContainer, toast } from 'react-toastify';
import Form from "react-validation/build/form";

import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import AddAssetService from "../../../../services/contract/asset/addAssetService";
import { getTrans as t } from "../../../../Localization/translations";
import Helper from "../../../../Helper";


function AsstesForLoan() {

const location = useLocation();
const id = location.state?.contract_id

const [asset_number, setAsset_number] = useState(null);
const [asset_desc, setAsset_desc] = useState(null);
const [license_number, setLicense_number] = useState(null);
const [year, setYear] = useState(null);
const [vin_number, setVin_number] = useState(null);
const [license_state, setLicense_state] = useState(null);
const [manufacturer, setManufacturer] = useState(null);
const [make, setMake] = useState(null);
const [model, setModel] = useState(null);
const [user_purpose, setUser_purpose] = useState(null);
const [residal_value, seTresidal_value] = useState(null);
const [reg_address, setReg_address] = useState([]);
const [reg_address1, setReg_address1] = useState(null);
const [vendor_name, setVendorName] = useState([]);
const [vendername1, setVendorName1] = useState(null);
const [delivery_date, setDelivery_date] = useState(null);
const [in_service_date, setIn_service_date] = useState(null);
const [milage, setMilage] = useState(null);
const [vehicle_cost, setVehicle_cost] = useState(0);
const [vehicle_cost_payto, setVehicle_cost_payto] = useState("Dealer");
const [tax_amount, setTax_amount] = useState(0);
const [tax_amount_payto, setTax_amount_payto] = useState("Dealer");
const [trade_in, setTrade_in] = useState(0);
const [trade_in_payto, setTrade_in_payto] = useState("Borrower");
const [reg_cost, setReg_cost] = useState(0);
const [reg_cost_payto, setReg_cost_payto] = useState("Dealer");
const [down_payment, setDown_payment] = useState(0);
const [down_payment_payto, setDown_payment_payto] = useState("Borrower");

const [successful, setSuccessful] = useState(false);
const checkBtn = useRef();
const { register, handleSubmit, formState: { errors } } = useForm();
const form = useRef();


const getaddress = async () => {
    const resst = await fetch(API + "parties/manage-addressinstall/" + id + "/?address_type=install_to", { headers: authHeader() });
    const getst = await resst.json();
    setReg_address(await getst.data);
}

useEffect(() => {
    getaddress();
    handelDefault();
}, [])

const handelDefault = async () => {
    const rsst = await fetch(API + "parties/vendor/?party_type=Vendor", { headers: authHeader() });
    const gtst = await rsst.json();
    setVendorName(await gtst);
}

let navigate = useNavigate();

const handleCancel = () => {
    navigate("/contract/edit", { state: id })
}

const handleRegister = () => {

    (tax_amount_payto === 'Dealer') ? (setTax_amount(tax_amount)) : (setTax_amount(0));
    (reg_cost_payto === 'Dealer') ? (setReg_cost(reg_cost)) : (setReg_cost(0));
    (trade_in_payto === 'Dealer') ? (setTrade_in(trade_in)) : (setTrade_in(0));
    (down_payment_payto === 'Dealer') ? (setDown_payment(down_payment)) : (setDown_payment(0));
    const total_cost = parseInt(vehicle_cost) + parseInt(tax_amount) + parseInt(reg_cost);
    const financed_amt = parseInt(total_cost) - parseInt(trade_in) - parseInt(down_payment);
    const dealer_pay = parseInt(total_cost) - parseInt(trade_in) - parseInt(down_payment);

    setSuccessful(false);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
        AddAssetService.addAsset(
            id,
            asset_number,
            asset_desc,
            license_number,
            financed_amt,
            year,
            vin_number,
            license_state,
            dealer_pay,
            manufacturer,
            make,
            model,
            user_purpose,
            residal_value,
            reg_address1,
            vendername1,
            Helper.DatePicker(delivery_date),
            Helper.DatePicker(in_service_date),
            milage,
            vehicle_cost,
            vehicle_cost_payto,
            tax_amount,
            tax_amount_payto,
            trade_in,
            trade_in_payto,
            reg_cost,
            reg_cost_payto,
            total_cost,
            down_payment,
            down_payment_payto,
        ).then(
            (response) => {
                if (response.data.success) {
                    setSuccessful(true);
                    setTimeout(() => {
                        navigate("/editloancontract", { state: id })
                    }, 1000)
                    toast.success(`${response.data.response}`)
                }
                else {
                    toast.error(`${response.data.error}`)
                    setSuccessful(false);
                }
            },
        )
    }
}

const handleAssetNumber = (e) => {
    setAsset_number(e.target.value)
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
        AddAssetService.assetsvalidation(
            asset_number
        ).then((response) => {
            if (response.data.success) {
            }
            else {
                confirmAlert({
                    title: "",
                    message: 'Assets Number already exist.',
                    buttons: [
                        {
                            label: 'ok',
                            onClick: () => setAsset_number("")
                        },
                    ]
                })
            }
        }).catch((error) => {
            toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
      
          });
    }
}


return (
<>
    <div className="container-fluid">
        <ToastContainer />
        <div className="header mb-2 pt-3">
            <h5 className="modal-title text-left">{t("Add Assets")}</h5>
        </div>
        <div className="card" role="document">
            <div className="card-body">
                <Form role="form text-left"
                    onSubmit={handleSubmit(handleRegister)}
                    ref={form}
                    action="."
                    method="POST"
                    id="addPartyContactForm" >
                    {(
                        <>
                            <div className="row">
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t('Asset No')} <Tooltip content={t("AssetNo_Tooltip")}><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={asset_number}
                                                onChange={(e) => handleAssetNumber(e)}
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t('Asset Description')} <Tooltip content={t("AssetDesc_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={asset_desc}
                                                onChange={(e) => setAsset_desc(e.target.value)}
                                                type="text" id="asset_desc" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("License No")} <Tooltip content={t("LicenseNo_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={license_number}
                                                onChange={(e) => setLicense_number(e.target.value)}
                                                type="text" name="license_number" id="license_number" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Financed Amount")} <Tooltip content={t("FinancedAmount_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                type="text" id="financed_amount" className="form-control" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Year")} <Tooltip content={t("Year_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={year}
                                                onChange={(e) => setYear(e.target.value)}
                                                type="text" id="year" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("VIN Number")} <Tooltip content={t("VINNumber_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={vin_number}
                                                onChange={(e) => setVin_number(e.target.value)}
                                                type="text" id="vin_number" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("License State")} <Tooltip content={t("LicenseState_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={license_state}
                                                onChange={(e) => setLicense_state(e.target.value)}
                                                type="text" name="license_state" id="license_state" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Dealer Payable")} <Tooltip content={t("DealerPayable_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                type="text" id="dealer_payable" className="form-control" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Manufacturer")} <Tooltip content={t("Manufacturer_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={manufacturer}
                                                onChange={(e) => setManufacturer(e.target.value)}
                                                type="text" id="manufacturer" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Make")} <Tooltip content={t("Make_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={make}
                                                onChange={(e) => setMake(e.target.value)}
                                                type="text" id="make" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Model")} <Tooltip content={t("Model_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={model}
                                                onChange={(e) => setModel(e.target.value)}
                                                type="text" name="Model" id="model" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Use Purpose")} <Tooltip content={t("UsePurpose_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={user_purpose}
                                                onChange={(e) => setUser_purpose(e.target.value)}
                                                type="text" name="Use_Purpose" id="user_purpose" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Residal Value")} <Tooltip content={t("ResidalValue_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={residal_value}
                                                onChange={(e) => seTresidal_value(e.target.value)}
                                                type="text" name="residal_value" id="residal_value" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h4 className="card-title">{t("Install Address")}</h4>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Address")} <Tooltip content={t("InstallAddress_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <select
                                                onChange={(e) => setReg_address1(e.target.value)}
                                                name="address_id"
                                                id="address_list"
                                                className="form-control input-lg"
                                                data-live-search="true"
                                                title="Select Address"
                                            >
                                                <option>---{t("Select Install Address")}---</option>
                                                {
                                                    reg_address.map((key) => (
                                                        <option key={key.id} value={key.id}>{key.address_line_1}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h4 className="card-title">{t("Supplier Details")}</h4>
                            <div className="row">
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Vendor Name")} <Tooltip content={t("VendorName_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <select
                                                name="vendorname1"
                                                id="vendor_list"
                                                className="form-control input-lg"
                                                {...register("vendorname1", { onChange: (e) => { setVendorName1(e.target.value) }, required: true })}
                                                required
                                            >
                                                <option value="">---{t("Select Vendor Name")}---</option>
                                                {
                                                    vendor_name.map((key1) => (
                                                        <option key={key1.id} value={key1.id}>{key1.customer_name}</option>
                                                    ))
                                                }
                                            </select>
                                            {errors.vendername1?.type === 'required' && "Vendor is required"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Delivery Date")} <Tooltip content={t("DeliveryDate_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <DatePicker
                                                className="form-control datepick"
                                                selected={delivery_date}
                                                onChange={(e) => setDelivery_date(e)}
                                                placeholderText={"mm/dd/yyyy"}
                                                showYearDropdown // year show and scrolldown alos
                                                scrollableYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("In-Service Date")} <Tooltip content={t("In-ServiceDate_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <DatePicker
                                                className="form-control datepick"
                                                selected={in_service_date}
                                                onChange={(e) => setIn_service_date(e)}
                                                placeholderText={"mm/dd/yyyy"}
                                                showYearDropdown // year show and scrolldown alos
                                                scrollableYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Mileage")} <Tooltip content={t("Mileage")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                value={milage}
                                                onChange={(e) => setMilage(e.target.value)}
                                                type="text" name="Milage" id="milage" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-4">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Vehicle Cost")} <Tooltip content={t("VehicleCost_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-6">
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                allowDecimals="false"
                                                value={vehicle_cost}
                                                onValueChange={(value) => setVehicle_cost(value)}
                                                className="form-control"
                                                disableAbbreviations
                                            />
                                        </div>
                                        <div style={{ padding: "0" }} className="col-lg-6">
                                            <select
                                                onChange={(e) => setVehicle_cost_payto(e.target.value)}
                                                id="vehicle_cost_payto" className="form-control">
                                                <option value="">{t("Select")}</option>
                                                <option value="Borrower">{t("Borrower")}</option>
                                                <option selected value="Dealer">{t("Dealer")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Tax")} <Tooltip content={t("Tax_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-6">
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                allowDecimals="false"
                                                value={tax_amount}
                                                onValueChange={(value) => setTax_amount(value)}
                                                className="form-control"
                                                disableAbbreviations
                                            />
                                        </div>
                                        <div style={{ padding: "0px 15px 0px 0px" }} className="col-lg-6">
                                            <select
                                                onChange={(e) => setTax_amount_payto(e.target.value)}
                                                id="tax_amount_payto" className="form-control">
                                                <option value="">{t("Select")}</option>
                                                <option value="Borrower">{t("Borrower")}</option>
                                                <option selected value="Dealer">{t("Dealer")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Trade In")} <Tooltip content={t("TradeIn_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-6">
                                            <input
                                                value={trade_in}
                                                onChange={(e) => setTrade_in(e.target.value)}
                                                type="text" name="trade_in" id="trade_in" className="form-control" />
                                        </div>
                                        <div className="col-lg-6">
                                            <select
                                                onChange={(e) => setTrade_in_payto(e.target.value)}
                                                id="trade_in_payto" className="form-control">
                                                <option value="">{t("Select")}</option>
                                                <option selected value="Borrower">{t("Borrower")}</option>
                                                <option value="Dealer">{t("Dealer")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-4">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Registration")} <Tooltip content={t("Registration_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-6">
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                allowDecimals="false"
                                                value={reg_cost}
                                                onValueChange={(value) => setReg_cost(value)}
                                                className="form-control"
                                                disableAbbreviations
                                            />
                                        </div>
                                        <div style={{ padding: "0" }} className="col-lg-6">
                                            <select
                                                onChange={(e) => setReg_cost_payto(e.target.value)}
                                                id="reg_cost_payto" className="form-control">
                                                <option value="">{t("Select")}</option>
                                                <option value="Borrower">{t("Borrower")}</option>
                                                <option selected value="Dealer">{t("Dealer")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="form-group row">
                                        <label className="col-lg-12  col-form-label">{t("Total Cost")} <Tooltip content={t("TotalCost_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-12">
                                            <input
                                                type="text" name="total_cost" id="total_cost" className="form-control" disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">{t("Down Payment")} <Tooltip content={t("DownPayment_Tooltip")} ><i class="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-lg-6">
                                            <CurrencyInput
                                                id="input-example"
                                                name="input-name"
                                                allowDecimals="false"
                                                value={down_payment}
                                                onValueChange={(value) => setDown_payment(value)}
                                                className="form-control"
                                                disableAbbreviations
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <select
                                                onChange={(e) => setDown_payment_payto(e.target.value)}
                                                id="down_payment_payto" className="form-control">
                                                <option value="">{t("Select")}</option>
                                                <option selected value="Borrower">{t("Borrower")}</option>
                                                <option value="Dealer">{t("Dealer")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-left py-3">
                                <input type="hidden" id="assetId" />
                                <button type="button" className="asset-cancel btn btn-secondary btn-md" onClick={handleCancel}>{t("Cancel")}</button>&nbsp;&nbsp;
                                <button type="submit" className="btn-assets border-0 btn btn-primary btn-gradient-primary btn-md">{t("Save")}</button>
                            </div>
                        </>
                    )}
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
            </div>
        </div>
    </div>
</>
)
}

export default AsstesForLoan